import './Navbar.css';

const Navbar = () => {
  return (
    <div className="navbar">
        <ul>
            <li> <a href="#ABOUTUS">ABOUT US</a> </li>
            <li><a href="#FORYOU">FOR YOU</a></li>
            <li><a href="#SERVICES">SERVICES</a></li>
            <li><a href="#BLOG">BLOG</a></li>
            <li><a href="#VLOG">VLOG</a></li>
            <li><a href="#CONTACT">CONTACT</a></li>
        </ul>
    </div>
  )
}

export default Navbar